import React, { Component } from 'react';
import Layout from '../../common/Layout';
import PropTypes from 'prop-types';
// import gql from "graphql-tag"; // TODO: Remove when all GraphQL queries are migrated
// import { Query } from "@apollo/client/react/components"; // TODO: Remove when all GraphQL queries are migrated
import DataTable from '../../common/components/data-table/DataTable';
import Fab from "@material-ui/core/Fab";
import AddIcon from '@material-ui/icons/Add';
import GetAppIcon from '@material-ui/icons/GetApp';
import plusButtonStyle from '../../settings/otherStyles';
import {client} from '../../settings/apollo';
import SimpleSearch from '../../common/components/data-table/SimpleSearch';
// import CSVService from '../CSVservice' // TODO: Re-enable when migrating CSV download to REST
import AdminSettingsNavigation from '../adminSettings/AdminSettingsNavigation';
import Select from 'react-select';
// import { GET_USER_GROUPS } from "./../userGroup/queries"; // TODO: Remove when migrated to REST
import { Button, Box } from '@material-ui/core';
import EventIcon from '@material-ui/icons/Event';
import './UserList.css';
import CalendarDialog from '../../common/components/Dialogs/CalendarDialog/CalendarDialog';
import moment from 'moment';
import Swal from 'sweetalert2';
import { Navigate } from 'react-router-dom';
import LoadingSpinner from "../../common/components/LoadingSpinner/LoadingSpinner";
import useAppStore from "../../store/appStore";
import { useUsers } from "../../hooks/useUsers";
import { useUpdateExpirationDate } from "../../hooks/useUpdateExpirationDate";
import { useUserGroups } from "../../hooks/useUserGroups";
import { useUsersDownload } from "../../hooks/useUsersDownload";
import { RolesTypes } from "../../constants/roles";

// Wrapper component to use hooks in class component
const UsersDataWrapper = ({ name, page, courseGroups, userGroup, onlineDeltaTime, userData, coachGroups, component }) => {
  
  const { data: usersData, isPending: isLoading, error } = useUsers({
    name,
    page, 
    courseGroups,
    userGroup,
    onlineDeltaTime,
    showCompletedChallenges: false
  });

  const { data: userGroupsData, isLoading: groupsLoading, error: groupsError } = useUserGroups();
  const updateExpirationDate = useUpdateExpirationDate();
  const downloadUsersMutation = useUsersDownload();

  // Pass the mutation functions to the component
  component.updateExpirationDateMutation = updateExpirationDate;
  component.downloadUsersMutation = downloadUsersMutation;

  if (groupsLoading || isLoading) return <LoadingSpinner boxed={true} styles={{ paddingTop: 40, marginTop: 15, marginBottom: 30 }} />;
  if (groupsError) return `Error loading groups! ${groupsError.message}`;
  if (usersData === null) return <b>This feature is available just to Administrators</b>;
  const userGroups = userGroupsData?.userGroups?.records?.map((item) => ({ value: item._id, label: item.name })) || [];
  const usersWithoutTime = {
    ...usersData.users,
    records: usersData.users.records.map(({ time, ...rest }) => rest)
  };
  return (
    <div className="wizard-container">
      {userData.userRole === RolesTypes.SUPERUSER ?
        <Fab onClick={component._add} color="primary" aria-label="Add" className={plusButtonStyle.fab}>
          <AddIcon />
        </Fab>
        : null}
      <AdminSettingsNavigation path={component.props.match.path} />

      <div className="row justify-content-end user-list__controls">
        <div className="col-xl-3 col-lg-12 text-right">
          {userData.userRole === RolesTypes.SUPERUSER ? 
          <Button
          variant="contained"
          color="primary"
          size="medium"
          className="btn-date"
          onClick={component.openDatePickerDialog}
        >
          <EventIcon /><span>Change expiration date</span>
        </Button>
        : null}
        </div>
        <div className="col-xl-2 col-lg-6">
            <SimpleSearch keyPress={component._keyPress} />
        </div>
        <div className="col-xl-3 col-lg-6">
          <Select
            styles={{
              menu: provided => ({ ...provided, zIndex: 9999 })
            }}
            value={component.state.onlineDeltaTime !== undefined ? 
              [{value: 0, label: 'offline'}, {value: 120, label: 'online'}].find(opt => opt.value === component.state.onlineDeltaTime) : 
              null
            }
            onChange={(values) => values != null ? component.setState({ onlineDeltaTime: values.value, page: 0, selected: [] }) : component.setState({ onlineDeltaTime: undefined, page: 0, selected: [] })}
            options={[{value: 0, label: 'offline'}, {value: 120, label: 'online' }]}
            isClearable={true}
            placeholder={"Select by user activity"}
          />
        </div>
        <div className="col-xl-3 col-lg-6">
          <Select
            styles={{
              menu: provided => ({ ...provided, zIndex: 9999 })
            }}
            value={component.state.userGroup ? 
              (userData.userRole ===  RolesTypes.SUPERUSER ? userGroups : coachGroups).find(opt => opt.value === component.state.userGroup) : 
              null
            }
            onChange={(values) => values != null ? component.setState({ userGroup: values.value, page: 0, selected: [] }) : component.setState({ userGroup: null, page: 0, selected: [] })}
            options={userData.userRole ===  RolesTypes.SUPERUSER ? userGroups : coachGroups}
            isClearable={true}
            placeholder={"Select course groups"}
          />
        </div>
      </div>
      {isLoading && <LoadingSpinner boxed={true} styles={{ paddingTop: 40, marginTop: 15, marginBottom: 30 }} />}
      {error && <div>Error! {error.message}</div>}
      {!isLoading && !error && (
        
      <DataTable
        key={`users-table-${page}-${usersWithoutTime?.records?.length || 0}-${JSON.stringify(usersWithoutTime?.records?.map(r => r.expirationDate) || [])}`}
        header='Users'
        editUrl="/admin-settings/users/"
        pages={usersWithoutTime?.pages}
        columns={columns}
        records={usersWithoutTime}
        deleteRow={component._deleteRow}
        keyColumn='_id'
        page={page}
        first={component._first}
        last={component._last.bind(component, usersWithoutTime?.pages)}
        next={component._nextPage}
        previous={component._previousPage}
        checkboxes={true}
        selected={component.state.selected}
        onSelectedIndex={component.handleSelectedIndexes}
        showDeleteIcon={component.handleDeleteAction}
        highlightRecord={component.highlightRecord}
        status={component.checkIsOnline}
        columnsToHide={columnsToHide}
        hasCustomAction={true}
        handleCustomActionClick={component.handleScheduleClick}
        customActionIcon={<i className="material-icons">history_edu</i>}
      />
      )}
      
      <Box mt={2} display="flex" justifyContent="center">
        <Button
          variant="outlined"
          color="primary"
          size="medium"
          onClick={component.handleDownloadUsers}
          startIcon={<GetAppIcon />}
        >
          Download Users Data
        </Button>
      </Box>

      <CalendarDialog
        value={moment()}
        onHandleDateChange={component.handleDateChange}
        ref={component.datePickerDialog}
        styleDialog={{display: "none"}}
      />
    </div>
  );
};


const columns = ["sigla", "name", "surname", "email", "expirationDate", "actions"];
const columnsToHide = ["lastRequest"];

/* TODO: Migrate CSV download query to REST API
const GET_USERS_TABLE = gql`
    query users($name:String, $page: Int, $courseGroups: [String], $userGroup: String, $onlineDeltaTime: Int, $showCompletedChallenges: Boolean){
        users(name:$name, page: $page, courseGroups: $courseGroups, userGroup: $userGroup, onlineDeltaTime: $onlineDeltaTime, showCompletedChallenges: $showCompletedChallenges){
        records{
            _id
            name
            surname
            sigla
            email
            userRole
            time
            courseGroups{
              name
            }
            privacyPolicy,
            profileScorecard,
            publishAchievement,
            completedChallengeIds
        }
        pages
        totalCount
        }
    }
`;
*/

/* TODO: Migrate expiration date update to REST API - COMPLETED
const UPDATE_USERS_EXPIRATION_DATE = gql `
mutation updateUsersExpirationDate($input: UsersExpirationDateInput){
  updateUsersExpirationDate(input: $input)
}
`;
*/

class Users extends Component {
  static propTypes = {
    page: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      page: props.match.params.page ? parseInt(props.match.params.page) : 0,
      selected: [],
      users:[],
      userGroup: null,
      onlineDeltaTime: undefined
    };
    this.datePickerDialog = React.createRef();
    this.openDatePickerDialog = this.openDatePickerDialog.bind(this);
    this.handleSelectedIndexes = this.handleSelectedIndexes.bind(this);
    this.handleDeleteAction = this.handleDeleteAction.bind(this);
    this.handleDownloadUsers = this.handleDownloadUsers.bind(this);
    this.handleScheduleClick = this.handleScheduleClick.bind(this);
    this._nextPage = this._nextPage.bind(this);
    this._previousPage = this._previousPage.bind(this);
    this._add = this._add.bind(this);
    this._first = this._first.bind(this);
    this._last = this._last.bind(this);
    this._first = this._first.bind(this);
    this._keyPress = this._keyPress.bind(this);
    this.today = moment();
    this.client = client;

  }
  

  _previousPage(e) {
    e.preventDefault();

    if (this.state.page > 0) {
      this.setState({ page: this.state.page - 1, selected: [] });
      // this.props.history.push('/admin-settings/users/page/'+(parseInt(this.state.page) - 1) )

    }
    else {
      this.setState({ page: 0, selected: []});
      // this.props.history.push('/admin-settings/users' )
    }
  }

  _nextPage(e) {
    e.preventDefault();
    this.setState({ page: this.state.page + 1, selected: [] });
    // this.props.history.push('/admin-settings/users/page/'+(parseInt(this.state.page) + 1) )

  }

  _first(e) {
    e.preventDefault();
    this.setState({ page: 0, selected: [] });
    // this.props.history.push('/admin-settings/users')
  }

  _last(pages, e) {
    e.preventDefault();
    this.setState({ page: pages - 1, selected: [] });
    // this.props.history.push('/admin-settings/users/page/'+(pages - 1))
  }

  _add(event) {
    this.props.history.push("/admin-settings/register");
  }

  _keyPress(e) {
    if (e.keyCode === 13) {
      this.setState({
        name: e.target.value,
        page: 0
      });
    }
  }

  isSelected(user){
    return user._id.this.state.selected
  }

  handleDateChange = date => {
    this.setState({ selected: [], users: [] });

    const ids = this.state.selected.map(index => {
      return this.state.users[index]._id;
    })
    
    // Use REST API mutation instead of GraphQL
    this.updateExpirationDateMutation.mutate(
      { expirationDate: date, ids: ids },
      {
        onSuccess: () => {
          Swal.fire({
            type: 'success',
            title: 'Expiring date changed.',
            showConfirmButton: false,
            timer: 1500
          })
        },
        onError: (error) => {
          console.log("error changing date", error)
          Swal.fire({
            type: 'error',
            title: 'Error changing expiration date',
            text: error.message,
            showConfirmButton: true
          })
        }
      }
    );
  };

  openDatePickerDialog = () => {
    if (this.state.selected.length===0) {
      Swal.fire({
        type: 'warning',
        text: 'Select users first.',
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: 'Close'
      })
      return;
    }
    this.datePickerDialog.current.open();
  }

  handleDownloadUsers = async () => {
    try {
      Swal.fire({
        title: 'Generating download...',
        text: 'Please wait',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Get user data from Zustand store
      const user = useAppStore.getState().user;
      const userData = user?.me;
      const UserGroupList = userData?.courseGroups?.map((item) => item.id) || [];

      // Call the download mutation with the same parameters as calculateDataCsv
      const blob = await this.downloadUsersMutation.mutateAsync({
        name: this.state.name,
        courseGroups: UserGroupList,
        userGroup: this.state.userGroup,
        onlineDeltaTime: this.state.onlineDeltaTime
      });

      // Create download link
      const fileName = `GAMSUserData_${moment().format('YYYY-MM-DD_HH-mm-ss')}.csv`;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      Swal.fire({
        type: 'success',
        title: 'Download completed!',
        showConfirmButton: false,
        timer: 1500
      });
    } catch (error) {
      console.error('Error downloading users:', error);
      Swal.fire({
        type: 'error',
        title: 'Download failed',
        text: error.message || 'An error occurred while downloading the file',
        showConfirmButton: true
      });
    }
  }

  handleSelectedIndexes = (selected, records) => {
   this.setState({selected: selected });
   this.setState({users: records});
  }

  handleDeleteAction = () => {
    return false;
  }

  handleScheduleClick = (record) => {
    window.open(`/challenge-results/student-schedule/${encodeURIComponent(record.email)}`, '_blank');
  }

  highlightRecord (record) {
    return (moment(record.expirationDate).isBefore(this.today));
  }

  checkIsOnline = (record) => {
    if (record.isLogged) {
      return 0;
    } else {
      const lastRequestDate = moment(record.lastRequest);
      const diff = ['weeks', 'days', 'hours', 'minutes'].filter(item => this.today.diff(lastRequestDate, item));
      return diff.length > 0 ? `${this.today.diff(lastRequestDate, diff[0])} ${diff[0]}` : false;
    }
  }

  /* TODO: Migrate CSV download functions to REST API
  buildCompletedChallengesCsvStringFormat(data) {
    return data?.length > 0 ? data.join(' - ') : null;
  }
  
  calculateDataCsv = async (UserGroupList) => {
    let result = [];
    await client.query({
      query: GET_USERS_TABLE,
      variables: { name: this.state.name, courseGroups: UserGroupList, userGroup: this.state.userGroup, onlineDeltaTime: this.state.onlineDeltaTime, showCompletedChallenges: true }
    }).then(res => {
      const data = res.data?.users;
      if (data === null) return null;
      let usersList = [];
      let courses;
      data.records.map((item) => {
        if (item.courseGroups) {
          courses = item.courseGroups.map((item) => item.name)
        }
        const newTime = moment.utc(item.time).format('YYYY/MM/DD hh:mm:ss')
        usersList.push({
          _id: item._id,
          name: item.name,
          surname: item.surname,
          sigla: item.sigla,
          email: item.email,
          _role: item.userRole,
          time: newTime,
          _userGroup: courses,
          PrivacyPolicy: item.privacyPolicy,
          ProfileScorecard: item.profileScorecard,
          PublishAchievement: item.publishAchievement,
          completedChallengeIds: this.buildCompletedChallengesCsvStringFormat(item.completedChallengeIds)
        });
        return null
      })

      result = usersList.map((item) => item);
    });
    return result;
  }
  */

  render() {
    // Get user data from Zustand store
    const user = useAppStore.getState().user;
    
    if(this.props.location.pathname.includes('page') &&
    !this.props.match.params.page)
    return (
      <Navigate
      to="../users"
      replace
    />
    )
    
    // Early return if no user data
    if (!user || !user.me) return <LoadingSpinner styles={{ paddingTop: 30 }}/>;
    
    const userData = user.me;
    const UserGroupList = []
    const coachGroups = []
    const courseGroups = userData.courseGroups?.map((item) => item) || []
    courseGroups.map((item) => {
      UserGroupList.push(item.id); coachGroups.push({ value: item.id, label: item.name })
      return null;
    })
    
    return (
      <Layout name="Users">
        <div className="user-list">
          <UsersDataWrapper
            name={this.state.name}
            page={this.state.page}
            courseGroups={UserGroupList}
            userGroup={this.state.userGroup}
            onlineDeltaTime={this.state.onlineDeltaTime}
            userData={userData}
            coachGroups={coachGroups}
            component={this}
          />
        </div>
      </Layout>
    );
  }
}

export default Users;
